module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (254).337382a6.jpg";